// extracted by mini-css-extract-plugin
export default {"Canceled":"UXx7AXQG","Block":"UFfUzjIb","Content":"Q8VLje0b"};